(function () {
  'use strict';

  function toCents(value) {
    var number = Number(value);

    return Number.isFinite(number) && number > 0
      ? Math.round(number)
      : 0;
  }

  function formatMoney(cents) {
    if (
      window.theme &&
      theme.Currency &&
      typeof theme.Currency.formatMoney === 'function'
    ) {
      return theme.Currency.formatMoney(
        cents,
        theme.settings.moneyFormat
      );
    }

    return '$' + (toCents(cents) / 100).toFixed(2);
  }

  function getTiers(element) {
    return [
      {
        threshold: toCents(element.dataset.tier1Threshold),
        discount: toCents(element.dataset.tier1Discount)
      },
      {
        threshold: toCents(element.dataset.tier2Threshold),
        discount: toCents(element.dataset.tier2Discount)
      },
      {
        threshold: toCents(element.dataset.tier3Threshold),
        discount: toCents(element.dataset.tier3Discount)
      }
    ].filter(function (tier) {
      return tier.threshold > 0 && tier.discount > 0;
    }).sort(function (first, second) {
      return first.threshold - second.threshold;
    });
  }

  function renderElement(element, subtotal) {
    var tiers = getTiers(element);
    var safeSubtotal = toCents(subtotal);

    if (!tiers.length || safeSubtotal <= 0) {
      element.hidden = true;
      return;
    }

    element.hidden = false;

    var unlockedTier = null;
    var nextTier = null;

    tiers.forEach(function (tier) {
      if (safeSubtotal >= tier.threshold) {
        unlockedTier = tier;
      } else if (!nextTier) {
        nextTier = tier;
      }
    });

    var segmentStart = unlockedTier
      ? unlockedTier.threshold
      : 0;

    var progress = 100;

    if (nextTier) {
      var segmentLength =
        nextTier.threshold - segmentStart;

      progress = segmentLength > 0
        ? (
            (safeSubtotal - segmentStart) /
            segmentLength
          ) * 100
        : 0;

      progress = Math.min(
        100,
        Math.max(0, progress)
      );
    }

    var messageElement = element.querySelector(
      '[data-cart-tiered-message]'
    );

    var trackElement = element.querySelector(
      '[data-cart-tiered-track]'
    );

    var message = '';

    if (!nextTier && unlockedTier) {
      message =
        'You unlocked the best deal: ' +
        '<strong>' +
        formatMoney(unlockedTier.discount) +
        ' OFF!</strong>';
    } else if (unlockedTier && nextTier) {
      message =
        'You unlocked ' +
        '<strong>' +
        formatMoney(unlockedTier.discount) +
        ' OFF.</strong> Add ' +
        '<strong>' +
        formatMoney(
          nextTier.threshold - safeSubtotal
        ) +
        '</strong> more to unlock ' +
        '<strong>' +
        formatMoney(nextTier.discount) +
        ' OFF!</strong>';
    } else if (nextTier) {
      message =
        'Add ' +
        '<strong>' +
        formatMoney(
          nextTier.threshold - safeSubtotal
        ) +
        '</strong> more to unlock ' +
        '<strong>' +
        formatMoney(nextTier.discount) +
        ' OFF!</strong>';
    }

    if (messageElement) {
      messageElement.innerHTML = message;
    }

    element.style.setProperty(
      '--cart-tier-progress',
      progress + '%'
    );

    if (trackElement) {
      trackElement.setAttribute(
        'aria-valuenow',
        String(Math.round(progress))
      );

      trackElement.setAttribute(
        'aria-valuetext',
        messageElement
          ? messageElement.textContent.trim()
          : ''
      );
    }
  }

  function renderAll(subtotal) {
    document
      .querySelectorAll('[data-cart-tiered-savings]')
      .forEach(function (element) {
        renderElement(element, subtotal);
      });
  }

  function loadCart() {
    var root =
      window.Shopify &&
      Shopify.routes &&
      Shopify.routes.root
        ? Shopify.routes.root
        : '/';

    return fetch(root + 'cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'Cart request failed: ' + response.status
          );
        }

        return response.json();
      })
      .then(function (cart) {
        renderAll(cart.items_subtotal_price);
      })
      .catch(function (error) {
        console.error(
          'Tiered savings cart progress failed.',
          error
        );
      });
  }

  document.addEventListener(
    'cart:updated',
    function (event) {
      var cart =
        event.detail && event.detail.cart
          ? event.detail.cart
          : null;

      if (cart) {
        renderAll(cart.items_subtotal_price);
      } else {
        loadCart();
      }
    }
  );

  document.addEventListener(
    'ajaxProduct:added',
    function () {
      window.setTimeout(loadCart, 150);
    }
  );

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      loadCart
    );
  } else {
    loadCart();
  }
})();